import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { ImportModel } from '../../../api/models';
import { EmployeeService, FileProcessingTaskService } from '../../../api/services';
import { AppNotificationServiceService } from '../../../shared/app-notification-service.service';
import { interval, Subscription } from 'rxjs';
import { flatMap } from 'rxjs/operators';

interface SelectFileParam {
  currentFiles: File[];
}
@Component({
  selector: 'app-modal-employee-import',
  templateUrl: './modal-employee-import.component.html',
  styleUrls: ['./modal-employee-import.component.css'],
})
export class ModalEmployeeImportComponent implements OnInit, OnDestroy {
  blob: Blob = null;
  model: any = {};
  form = new FormGroup({});
  fields: FormlyFieldConfig[] = [
    {
      key: 'file',
      type: 'upload-file',
      templateOptions: {
        translate: true,
        attributes: {
          style: 'width: 100%',
        },
        label: 'employee_d_excel',
        chooseLabel: 'อัพโหลด',
        previewWidth: 150,
        placeholder: '@blank',
        required: false,
        labelClass: 'col-4',
        inputClass: 'col-6',
        onSelect: (selectFileParam: SelectFileParam) => {
          this.blob = new Blob([selectFileParam.currentFiles[0]]);
        },
        onRemove: (_, model: any, oldDocumentId: number) => { },
      },
    },
  ];
  step = 1;
  importModel: ImportModel = {};
  subscription: Subscription;

  constructor(
    private employeeService: EmployeeService,
    private notificationService: AppNotificationServiceService,
    private ref: DynamicDialogRef,
    private config: DynamicDialogConfig,
    private fileProcessingTaskService: FileProcessingTaskService
  ) { }

  ngOnInit(): void { }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  submit1() {
    if (this.blob == null) {
      this.notificationService.error('ข้อผิดพลาด', 'กรุณาเลือกไฟล์ที่จะนำเข้า');
      return;
    }
    console.log(this.model);
    this.employeeService
      .ImportExcelStep1(this.blob)
      .subscribe(result => {
        this.importModel = result;
        this.step = 2;
      })
      .add(() => {
        // finally
      });
  }

  submit2() {
    this.employeeService
      .ImportExcelStep2(this.importModel)
      .subscribe(result => {
        this.notificationService.success('ผลการนำเข้า', 'นำเข้าสำเร็จ');
        this.close();
        // this.subscription = interval(5000)
        //   .pipe(
        //     flatMap(() => {
        //       return this.fileProcessingTaskService.GetFileProcessingTask(result);
        //     })
        //   )
        //   .subscribe((taskModel) => {
        //     if (!this.subscription.closed) {
        //       if (taskModel.fileProcessingStatus === 'Success') {
        //         this.subscription.unsubscribe();
        //         this.notificationService.success('ผลการนำเข้า', 'นำเข้าสำเร็จ');
        //         this.close();
        //       } else if (taskModel.fileProcessingStatus === 'Error') {
        //         this.subscription.unsubscribe();
        //         this.notificationService.error('ผลการนำเข้า', 'นำเข้าไม่สำเร็จ');
        //         this.close();
        //       }
        //     }
        //   }, err => {
        //     console.log(err);
        //     this.notificationService.error('ผลการนำเข้า', 'นำเข้าไม่สำเร็จ');
        //     this.close();
        //   });
      })
      .add(() => {
        // finally
      });
  }
  close() {
    this.ref.close();
  }
}
